import { c as _c } from "react/compiler-runtime";
import { HotelCardActionPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-action.types";
import { HotelCardPricing } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-pricing";
import { HotelCardReservationInfo } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-reservation-info";
import { HotelCardLink } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { useCompatRouter } from "@website/hooks/compat-router";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { FC } from "react";
export const HotelCardAction: FC<HotelCardActionPropertiesType> = properties => {
  const $ = _c(20);
  const {
    clickLoading,
    pricingInfo,
    roomTitle,
    reservationInfo,
    roomCount,
    isFomo,
    size: t0,
    isAvailable,
    loading,
    linkProperties,
    isLanding,
    hasSnappProDiscount,
    isHotelDomHomePage,
    isVillaHomePage,
    actionButtonText
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const appName = process.env.NEXT_PUBLIC_APP_NAME;
  const router = useCompatRouter();
  const t1 = size === "small" ? "flex shrink-0 flex-col items-stretch justify-between" : `flex w-full flex-row flex-wrap items-stretch justify-between md:h-full ${size === "medium" ? "max-w-[161px]" : "md:min-w-[200px] lg:max-w-[213px]"} md:flex-col md:flex-nowrap md:justify-end md:ps-4 lg:shrink-0 lg:ps-0`;
  let t2;
  if ($[0] !== actionButtonText || $[1] !== clickLoading || $[2] !== hasSnappProDiscount || $[3] !== isAvailable || $[4] !== isFomo || $[5] !== isHotelDomHomePage || $[6] !== isLanding || $[7] !== isVillaHomePage || $[8] !== linkProperties || $[9] !== loading || $[10] !== pricingInfo || $[11] !== reservationInfo || $[12] !== roomCount || $[13] !== roomTitle || $[14] !== router || $[15] !== size) {
    t2 = isAvailable ? <><div className="flex flex-1 flex-col justify-center">{isFomo && !loading && size !== "xSmall" && <div className={`mt-2 flex h-auto items-center gap-1 md:mt-0 lg:justify-center lg:pb-6 ${size === "small" ? "mt-2 !pb-2 md:mt-0 md:!justify-start" : ""}`}><MaterialIcon className="text-error text-sm lg:text-base" name="info" variant="outlined" /><span className="text-caption text-on-surface-high-emphasis truncate" data-testid="hotel_card_room_count"><span className="text-error">{`فقط ${numberConvert(roomCount, {
                numberOnly: false,
                locale: router.locale || "fa"
              })} اتاق باقی مانده`}</span></span></div>}<div className={`hotel-card-pricing flex w-full flex-row items-center justify-between pt-2 md:pt-0 ${!isFomo && "lg:flex-1 lg:justify-center"} ${size === "small" ? "lg:justify-between" : "lg:flex-col lg:gap-2"}`}><HotelCardReservationInfo {...reservationInfo} isHotelDomHomePage={isHotelDomHomePage} roomTitle={roomTitle} size={size} isLanding={isLanding} /><HotelCardPricing {...pricingInfo} nightCount={reservationInfo?.nightCount} size={size} hasSnappProDiscount={hasSnappProDiscount} /></div></div>{appName === "tour" ? <div className="text-on-surface-medium-emphasis mt-1 flex w-full flex-row items-center justify-between text-xs md:mt-0"><span>مجموع{" "}{numberConvert(reservationInfo?.passengersCount, {
            locale: "fa"
          })}{" "}نفر از</span><span>{numberConvert(numberSeparator(reservationInfo?.totalPrice || 0), {
            locale: "fa"
          })}{" "}تومان</span></div> : null}<HotelCardLink {...linkProperties} className={`mt-3 w-full ${size === "small" ? "md:hidden" : "md:mt-6"}`}><Button className="hotel-card-cta" divButtonType={true} fullWidth={true} loading={clickLoading && router?.query?.modal !== "review"}>{appName === "villa" || isVillaHomePage ? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0648 \u0631\u0632\u0631\u0648" : appName === "tour" ? actionButtonText : " \u0645\u0634\u0627\u0647\u062F\u0647 \u0627\u062A\u0627\u0642\u200C\u0647\u0627 \u0648 \u0631\u0632\u0631\u0648"}</Button></HotelCardLink></> : <div className="flex size-full flex-col items-center"><div className="flex h-full flex-row items-center justify-center gap-3 pb-3 lg:flex-col lg:pb-0"><span className="text-body-2 text-error font-bold">تکمیل ظرفیت</span><div className="text-caption flex flex-row gap-1"><MaterialIcon name="info" variant="outlined" /><span>تاریخ دیگری را بررسی کنید</span></div></div><div className="w-full"><HotelCardLink {...linkProperties} className={`mt-3 w-full ${size === "small" ? "md:hidden" : "md:mt-6"}`}><Button color="neutral" divButtonType={true} fullWidth={true} loading={clickLoading} loadingColor="primary" text={`مشاهده ${appName === "villa" || isVillaHomePage ? "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647" : appName === "tour" ? actionButtonText : "\u0647\u062A\u0644"}  `} variant="outline" /></HotelCardLink></div></div>;
    $[0] = actionButtonText;
    $[1] = clickLoading;
    $[2] = hasSnappProDiscount;
    $[3] = isAvailable;
    $[4] = isFomo;
    $[5] = isHotelDomHomePage;
    $[6] = isLanding;
    $[7] = isVillaHomePage;
    $[8] = linkProperties;
    $[9] = loading;
    $[10] = pricingInfo;
    $[11] = reservationInfo;
    $[12] = roomCount;
    $[13] = roomTitle;
    $[14] = router;
    $[15] = size;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== t1 || $[18] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
};